<template>
    <span :class="groupClass">
        <button
            type="submit"
            class="button"
            :class="cssClass"
            v-if="!submitting"
            v-html="computedOnLabel"
            @click="trigger()"
        ></button>
        <button
            type="button"
            class="button"
            :class="cssClass"
            v-if="submitting"
            v-html="computedOffLabel"
            disabled
        ></button>
    </span>
</template>
<script>
    export default {
        props: {
            submitting: {
                type: Boolean,
                default: false
            },
            labelOn: {
                type: String,
                required: false
            },
            labelOff: {
                type: String,
                required: false
            },
            icon: {
                type: String,
                required: false
            },
            cssClass: {
                type: String,
                required: false
            },
            groupClass: {
                type: String,
                required: false
            },
            fireEvent: {
                type: String,
                required: false
            }
        },
        computed: {
            computedOnLabel() {
                if (!this.icon) {
                    return this.labelOn;
                }
                let icon = '<span class="' + this.icon + '"></span>';
                if (!this.labelOn) {
                    return icon;
                }
                return icon + ' ' + this.labelOn;
            },
            computedOffLabel() {
                let icon = '<i class="fas fa-spin fa-spinner fa-fw"></i>';
                if (!this.labelOff) {
                    return icon;
                }
                return icon + ' ' + this.labelOff;
            }
        },
        methods: {
            trigger() {
                if (this.fireEvent) {
                    window.EventHandler.fire(this.fireEvent);
                }
            }
        }
    }
</script>